import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["number"]
  static values = {
    end: Number,
    duration: { type: Number, default: 2000 }
  }

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true
            this.animateCounter()
          }
        })
      },
      { threshold: 0.5 }
    )

    this.observer.observe(this.element)
    this.hasAnimated = false
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  animateCounter() {
    const target = this.endValue
    const duration = this.durationValue
    const startTime = performance.now()
    const startValue = 0

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)

      // Easing function (easeOutExpo)
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress)

      const currentValue = Math.floor(startValue + (target - startValue) * easeProgress)

      // Format the number with suffix if exists
      this.numberTarget.textContent = this.formatNumber(currentValue)

      if (progress < 1) {
        requestAnimationFrame(animate)
      } else {
        // Ensure we display the final value with original formatting
        this.numberTarget.textContent = this.element.dataset.counterOriginal
      }
    }

    requestAnimationFrame(animate)
  }

  formatNumber(value) {
    const original = this.element.dataset.counterOriginal

    // Check if original has a suffix like +, %, etc.
    const suffix = original.match(/[+%]/) ? original.match(/[+%]/)[0] : ''

    return value + suffix
  }
}
